<template>
  <BContainer class="container-pages ad-owner-actions" v-if="advertisementDisplay">
    <BRow>
      <BCol
        v-if="useStoreCustomer.customer && useStoreCustomer.customer.id == advertisementDisplay.customer_id"
        class="mb-2"
      >
        <div class="owner-action-card">
          <div class="owner-action-header">
            <div class="owner-action-eyebrow">Upravljanje oglasom</div>
            <div class="owner-action-title">Opcije za vaš oglas</div>
          </div>

          <div class="owner-action-buttons">
            <NuxtLink
              class="btn owner-btn owner-btn-primary"
              :to="{
                name: 'korisnicki-profil-promena-podataka-id',
                params: { id: advertisementDisplay.id }
              }"
            >
              Promenite
            </NuxtLink>

            <button
              class="btn owner-btn owner-btn-muted"
              @click="renewalItems(advertisementDisplay.id)"
            >
              Obnovite
            </button>

            <button
              class="btn owner-btn owner-btn-muted"
              @click="updateSellItems(advertisementDisplay.id)"
            >
              {{ advertisementDisplay.status != 'sold' ? 'Nije prodat' : 'Prodat' }}
            </button>
          </div>
        </div>
      </BCol>
    </BRow>
  </BContainer>
</template>

<script setup>
import { BContainer, BRow, BCol } from 'bootstrap-vue-next'
import { useAdvertisementStore } from "~/stores/advertisement"
import { useCustomerLoginStore } from "~/stores/login/customer"

const useStore = useAdvertisementStore()
const useStoreCustomer = useCustomerLoginStore()

const props = defineProps({
  advertisement: {
    required: true,
    type: Object
  }
})

const advertisementDisplay = ref()

const updateSellItems = async (id, value) => {
  const { data, success } = await useStore.updateSellItems(id, value)

  if (!success) return

  advertisementDisplay.value.status = data.status
}

const renewalItems = async (id) => {
  const Swal = (await import('sweetalert2')).default

  const { success } = await useStore.renewalItems(id)

  if (!success) return

  Swal.fire({
    title: "Oglas je uspesno obnovljen!",
    icon: "success",
    position: 'top-end'
  })
}

watchEffect(() => {
  advertisementDisplay.value = props.advertisement
})
</script>

<style scoped>

</style>